import $ from 'jquery';

class Loader {

    constructor() {
        $(document).ready(() => {
            this.$loader = $('.js-loader-container');
            if (this.$loader.length) {
                this.listen()
            }
        });
    }

    listen() {
        document.addEventListener('loader.show', this.show.bind(this));
        document.addEventListener('loader.hide', this.hide.bind(this));
    }

    show() {
        this.$loader
            .css('display', 'flex')
            .hide()
            .fadeIn(300);
        // close after 30sec
        this.timeout = setTimeout(this.hide.bind(this), 30000)
    }

    hide() {
        this.$loader.fadeOut(300);
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    }
}

export default Loader;
